import { bindActionCreators } from 'redux'
import * as login from '../../../common/actions/login'
import * as language from '../../../common/actions/language'
import * as amenities from '../../../common/actions/classification/amenities'
import * as cancelPolicies from '../../../common/actions/classification/cancel_policies'
import * as roomTypes from '../../../common/actions/classification/room_types'
import * as propertyTypes from '../../../common/actions/classification/property_types'
import * as listing from '../../../common/actions/listing.js'
import * as search from '../../../common/actions/search'
import * as review from '../../../common/actions/review'
import * as bedTypes from '../../../common/actions/room_group/bed_types'
import * as modal from '../../../common/actions/modal'

export default dispatch => ({
  login: bindActionCreators(login, dispatch),
  language: bindActionCreators(language, dispatch),
  listing: bindActionCreators(listing, dispatch),
  amenities: bindActionCreators(amenities, dispatch),
  cancelPolicies: bindActionCreators(cancelPolicies, dispatch),
  roomTypes: bindActionCreators(roomTypes, dispatch),
  propertyTypes: bindActionCreators(propertyTypes, dispatch),
  search: bindActionCreators(search, dispatch),
  review: bindActionCreators(review, dispatch),
  bedTypes: bindActionCreators(bedTypes, dispatch),
  modal: bindActionCreators(modal, dispatch)
})
